webpackJsonp([227638899823042],{

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _whatsNewContent = __webpack_require__(34);
	
	var _whatsNewContent2 = _interopRequireDefault(_whatsNewContent);
	
	var _ati_logo = __webpack_require__(118);
	
	var _ati_logo2 = _interopRequireDefault(_ati_logo);
	
	var _helpers = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Articles = function (_React$Component) {
	  _inherits(Articles, _React$Component);
	
	  function Articles() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Articles);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderHeroImage = function (article) {
	      if (article.hero == null) {
	        return _ati_logo2.default;
	      } else {
	        return article.hero;
	      }
	    }, _this.renderArticle = function (article) {
	      if (article != null && article.data.type != "ad") {
	        return _react2.default.createElement(
	          'article',
	          { className: 'c-news__article--with-img' },
	          _react2.default.createElement('img', { src: _this.renderHeroImage(article), alt: '', className: 'c-news__article-img' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'c-news__article-text' },
	            _react2.default.createElement(
	              'h1',
	              { className: 't-h2' },
	              article.title
	            ),
	            _react2.default.createElement('p', { className: 't-p t-p-light mt20', dangerouslySetInnerHTML: (0, _helpers.createHtmlText)(article.intro) }),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/articles?id=" + article.id, className: 'c-btn t-link mt30' },
	              'Read More'
	            )
	          )
	        );
	      }
	    }, _this.renderArticles = function (newsData) {
	
	      var articleData = newsData.map(function (article) {
	        return _this.renderArticle(article);
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'c-news o-container o-section' },
	        articleData
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Articles.prototype.render = function render() {
	    return this.renderArticles(_whatsNewContent2.default);
	  };
	
	  return Articles;
	}(_react2.default.Component);
	
	exports.default = Articles;
	module.exports = exports['default'];

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ATI_Web_Ads_870X375_Alabama.82690ef0.png";

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ATI_Web_Ads_870X375_Arkansas.9b2e502d.png";

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ATI_Web_Ads_870X375_Kentucky.e0e9a41a.png";

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ATI_Web_Ads_870X375_Louisiana.e7e58129.png";

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ATI_Web_Ads_870X375_Mississippi.dcd005cd.png";

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ATI_Web_Ads_870X375_Missouri.4b600be5.png";

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ATI_Web_Ads_870X375_Tennessee.899733b8.png";

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ATI_Web_Ads_870X375_WestVirginia.564e4bb7.png";

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Chic_&_Secluded_Banner.9b76b942.jpg";

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Chic_&_Unique_372X480.5ac035f4.png";

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Where_Next_Cover_2025.5d523ab8.jpg";

/***/ }),

/***/ 118:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/whats-new__hero.091795c8.jpg";

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/whereNextBannerImage.ebc21916.jpg";

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Header = __webpack_require__(6);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _whatsNew__hero = __webpack_require__(120);
	
	var _whatsNew__hero2 = _interopRequireDefault(_whatsNew__hero);
	
	var _Articles = __webpack_require__(184);
	
	var _Articles2 = _interopRequireDefault(_Articles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = function Page() {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'What\'s New | Who We Are'
	      // meta={[{ name: 'description', content: '' }]}
	    }),
	    _react2.default.createElement(
	      _Header2.default,
	      { hero: _whatsNew__hero2.default },
	      _react2.default.createElement(
	        'h1',
	        { className: 't-hero' },
	        'What\'s New'
	      )
	    ),
	    _react2.default.createElement(
	      'main',
	      { id: 'content', style: { height: "100%" } },
	      _react2.default.createElement(
	        'div',
	        { className: 'o-container' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'c-breadcrumbs mt30' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/' },
	              'Home'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/who-we-are' },
	              'Who We Are'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/who-we-are/whats-new', activeClassName: 'is-active' },
	              'What\'s New'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_Articles2.default, null)
	    )
	  );
	};
	
	exports.default = Page;
	module.exports = exports['default'];

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Where_Next_Cover_ = __webpack_require__(53);
	
	var _Where_Next_Cover_2 = _interopRequireDefault(_Where_Next_Cover_);
	
	var _whereNextBannerImage = __webpack_require__(54);
	
	var _whereNextBannerImage2 = _interopRequireDefault(_whereNextBannerImage);
	
	var _Chic__Unique_372X = __webpack_require__(52);
	
	var _Chic__Unique_372X2 = _interopRequireDefault(_Chic__Unique_372X);
	
	var _Chic__Secluded_Banner = __webpack_require__(51);
	
	var _Chic__Secluded_Banner2 = _interopRequireDefault(_Chic__Secluded_Banner);
	
	var _ATI_Web_Ads_870X375_Alabama = __webpack_require__(43);
	
	var _ATI_Web_Ads_870X375_Alabama2 = _interopRequireDefault(_ATI_Web_Ads_870X375_Alabama);
	
	var _ATI_Web_Ads_870X375_Arkansas = __webpack_require__(44);
	
	var _ATI_Web_Ads_870X375_Arkansas2 = _interopRequireDefault(_ATI_Web_Ads_870X375_Arkansas);
	
	var _ATI_Web_Ads_870X375_Louisiana = __webpack_require__(46);
	
	var _ATI_Web_Ads_870X375_Louisiana2 = _interopRequireDefault(_ATI_Web_Ads_870X375_Louisiana);
	
	var _ATI_Web_Ads_870X375_Mississippi = __webpack_require__(47);
	
	var _ATI_Web_Ads_870X375_Mississippi2 = _interopRequireDefault(_ATI_Web_Ads_870X375_Mississippi);
	
	var _ATI_Web_Ads_870X375_Missouri = __webpack_require__(48);
	
	var _ATI_Web_Ads_870X375_Missouri2 = _interopRequireDefault(_ATI_Web_Ads_870X375_Missouri);
	
	var _ATI_Web_Ads_870X375_WestVirginia = __webpack_require__(50);
	
	var _ATI_Web_Ads_870X375_WestVirginia2 = _interopRequireDefault(_ATI_Web_Ads_870X375_WestVirginia);
	
	var _ATI_Web_Ads_870X375_Kentucky = __webpack_require__(45);
	
	var _ATI_Web_Ads_870X375_Kentucky2 = _interopRequireDefault(_ATI_Web_Ads_870X375_Kentucky);
	
	var _ATI_Web_Ads_870X375_Tennessee = __webpack_require__(49);
	
	var _ATI_Web_Ads_870X375_Tennessee2 = _interopRequireDefault(_ATI_Web_Ads_870X375_Tennessee);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	  id: 1,
	  title: "Where Next 2025",
	  intro: "Check out ATI’s recently released version of our In-Tour magazine “Where Next” Partnering with destinations across North America, “Where Next” inspires visitors to plan their next North American journey while enjoying an ATI tour. The magazine is distributed to all ATI touring passengers, who have chosen to experience North America for their holiday.",
	  hero: _Where_Next_Cover_2.default,
	  titleImage: _whereNextBannerImage2.default,
	  link: { location: "http://images.americantours.com/files/AgentPortal/Sales%20Agent%20Portal%20Files/Where%20Next/Where_Next_Magazine_2025.pdf", link_text: "Check out Where Next!" },
	  data: [{
	    title: "Where Next 2025",
	    type: "p_with_image",
	    image: _Where_Next_Cover_2.default,
	    text: "Check out ATI’s recently released version of our In-Tour magazine “Where Next” Partnering with destinations across North America, “Where Next” inspires visitors to plan their next North American journey while enjoying an ATI tour. The magazine is distributed to all ATI touring passengers, who have chosen to experience North America for their holiday."
	  }, {
	    type: "pdf"
	  }]
	}, {
	  id: 2,
	  title: "Alabama",
	  hero: _ATI_Web_Ads_870X375_Alabama2.default,
	  link: {
	    "location": "/landingpages/destination/alabama.html"
	  },
	  data: {
	    title: "Alabama Ad",
	    type: "ad",
	    image: _ATI_Web_Ads_870X375_Alabama2.default
	  }
	}, {
	  id: 3,
	  title: "Arkansas",
	  hero: _ATI_Web_Ads_870X375_Arkansas2.default,
	  link: {
	    "location": "/landingpages/destination/arkansas.html"
	  },
	  data: {
	    title: "Arkansas Ad",
	    type: "ad",
	    image: _ATI_Web_Ads_870X375_Arkansas2.default
	  }
	}, {
	  id: 4,
	  title: "Louisiana",
	  hero: _ATI_Web_Ads_870X375_Louisiana2.default,
	  link: {
	    "location": "/landingpages/destination/louisiana.html"
	  },
	  data: {
	    title: "Louisiana Ad",
	    type: "ad",
	    image: _ATI_Web_Ads_870X375_Louisiana2.default
	  }
	}, {
	  id: 5,
	  title: "Mississippi",
	  hero: _ATI_Web_Ads_870X375_Mississippi2.default,
	  link: {
	    "location": "/landingpages/destination/mississippi.html"
	  },
	  data: {
	    title: "Mississippi Ad",
	    type: "ad",
	    image: _ATI_Web_Ads_870X375_Mississippi2.default
	  }
	}, {
	  id: 6,
	  title: "Missouri",
	  hero: _ATI_Web_Ads_870X375_Missouri2.default,
	  link: {
	    "location": "/landingpages/destination/missouri.html"
	  },
	  data: {
	    title: "Missouri Ad",
	    type: "ad",
	    image: _ATI_Web_Ads_870X375_Missouri2.default
	  }
	}, {
	  id: 7,
	  title: "WestVirginia",
	  hero: _ATI_Web_Ads_870X375_WestVirginia2.default,
	  link: {
	    "location": "/landingpages/destination/westvirginia.html"
	  },
	  data: {
	    title: "WestVirginia Ad",
	    type: "ad",
	    image: _ATI_Web_Ads_870X375_WestVirginia2.default
	  }
	}, {
	  id: 8,
	  title: "Kentucky",
	  hero: _ATI_Web_Ads_870X375_Kentucky2.default,
	  link: {
	    "location": "/landingpages/destination/kentucky.html"
	  },
	  data: {
	    title: "Kentucky Ad",
	    type: "ad",
	    image: _ATI_Web_Ads_870X375_Kentucky2.default
	  }
	}, {
	  id: 9,
	  title: "Tennessee",
	  hero: _ATI_Web_Ads_870X375_Tennessee2.default,
	  link: {
	    "location": "/landingpages/destination/tennessee.html"
	  },
	  data: {
	    title: "Tennessee Ad",
	    type: "ad",
	    image: _ATI_Web_Ads_870X375_Tennessee2.default
	  }
	}, {
	  id: 10,
	  title: "Chic & Unique",
	  intro: "ATI presents our new Chic & Unique hotel collection featuring our favorite properties in bustling urban and scenic rural settings across North America.",
	  hero: _Chic__Unique_372X2.default,
	  titleImage: _Chic__Secluded_Banner2.default,
	  link: { location: "http://images.americantours.com/files/AgentPortal/Sales%20Agent%20Portal%20Files/Where%20Next/Chic_&_Unique_2024_112524.pdf", link_text: "Click Here For Brochure" },
	  data: [{
	    title: "Our favorite Chic & Unique properties are based in suburban, rural, or resort destinations amidst natural surroundings that are breaming with outdoor experiences.",
	    type: "p_with_image",
	    image: _Chic__Unique_372X2.default,
	    text: "ATI's Chic & Unique collection features properties that either embody the unique cultural features of a destination, present an element of history or are iconic in their own right, provide a level of luxury that is unparalleled, offer an immersive experience to their guest that takes them away from the pressures of the modern world, or some combination thereof. Learn more about these fabulous accommodations today!"
	  }, {
	    type: "pdf"
	  }]
	}];
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-who-we-are-whats-new-js-197c92f204b3597d9a6d.js